const IconMode = {

	// Vessels coloured by difference betweeen closest data point and time slider.
	TIME_DIFFERENCE: "TIME_DIFFERENCE",

	// Vessels coloured by difference between data point and previous data point.
	// TODO: We need to figure out what we do in cases where there is no historic data,
	//		 and also in cases where it's the oldest and newest data point.
	TIME_SINCE_PREVIOUS_UPDATE: "TIME_SINCE_PREVIOUS_UPDATE",

	ALERT: "ALERTS",
	SPEED: "SPEED",
	VESSEL_TYPE: "VESSEL_TYPE", // vessel.classification

	// Vessels coloured by their index in their Vessel Group.
	INDEX: "INDEX",

	// Risk level for RIM alerts
	RISK_LEVEL: "RISK_LEVEL",

	AVIATION_ALERT: "AVIATION_ALERTS",
	AVIATION_SIL: "AVIATION_SIL",
	AVIATION_NACP: "AVIATION_NACP"
};
export default IconMode;
